var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index",attrs:{"id":"index"}},[_c('HeaderPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }